import React from 'react';

function BetaInput({ value, onChange }) {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Allow empty string, decimal point, and numbers
    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
      onChange(inputValue);
    }
  };

  const handleBlur = () => {
    // Convert to float and validate on blur
    const floatValue = parseFloat(value);
    if (isNaN(floatValue) || floatValue < 0) {
      onChange('0.1');
    } else {
      onChange(floatValue.toString());
    }
  };

  return (
    <div id="beta-input-wrapper" className="beta-input">
      <label htmlFor="beta-risk-input">Beta Risk</label>
      <input
        id="beta-risk-input"
        type="text"
        placeholder="0.95"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        className="beta-input-field"
        aria-describedby="beta-risk-hint"
      />
      <span id="beta-risk-hint" className="sr-only">Enter target beta, e.g. 0.95</span>
    </div>
  );
}

export default BetaInput;
